/**
 * useDisplayTimezone — THE timezone every authenticated surface renders
 * dates in (FRONTEND_PATTERNS.md § Timezones).
 *
 * Returns the user's profile timezone. The backend guarantees the field is
 * always a resolved, valid IANA zone (unset/invalid stored values → "UTC" —
 * see CustomUserSerializer.to_representation), so there is no fallback logic
 * here for the frontend to get wrong: LOADING_FALLBACK_TIMEZONE below only
 * covers the profile-fetch loading window and error states.
 *
 * Never use the browser timezone instead (banned by the resolvedOptions
 * ESLint rule); public booking pages — where the anonymous visitor has no
 * profile — use detectBrowserTimezone from @/lib/scheduling/useTimezone.
 */

import { useUserProfileData } from '@/hooks/useUserProfileData';
import { LOADING_FALLBACK_TIMEZONE } from '@/lib/time/loadingFallbackTimezone';

export function useDisplayTimezone(): string {
  const { data } = useUserProfileData();
  return data?.user?.timezone || LOADING_FALLBACK_TIMEZONE;
}
